const QueryKeys = {
  Leaderboard: 'Leaderboard',
  Rank: 'Rank',
  Me: 'Me',
  Online: 'Online',
};

export default QueryKeys;
